import BenchmarkTable from './BenchmarkTable'

export default BenchmarkTable
